import { Box, Button, Container, Typography, useMediaQuery } from "@mui/material";
import NavbarLogo from "./NavbarLogo";
import NavbarItem from "./NavBarItem";
import { navbarData } from "./navabarData";
import "./Navbar.css";
import React, { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Logout from "../Logout/Logout";
import { useAppSelector } from "../../store";
import { selectAuthUser } from "../../store/selectors";


export default function Navbar() {
  const [isClosed, setIsClosed] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width:1000px)');
  const user = useAppSelector(selectAuthUser);
  const isAdmin = user?.role === 'admin';

  const handleClick = () => {
    setIsClosed(!isClosed);
  };

  return (
    <Box
      className={`navbar ${isClosed ? "closed" : ""}`}
      sx={{
        backgroundColor: "navbar.main",
        borderRight: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box sx={{ marginBottom: "40px" ,  }}>
        <NavbarLogo closed={isClosed} />
      </Box>
      <Box className={`navitem-container ${isClosed ? "closed" : ""}`}>
        <Box>
          {navbarData.filter(item => !item.adminOnly || isAdmin).map((item) => {
            return (
              <NavbarItem
                key={item.name}
                name={item.name}
                href={item.href}
                Icon={item.Icon}
                closed={isClosed}
              />
            );
          })}
        </Box>
        <Box sx={{ display: "flex", gap: "10px" , flexDirection: isSmallScreen ? "column" : "row" , justifyContent: "space-between" , alignItems: "center" }}>     
          <Logout isClosed={isClosed} />
          <Box
            className={`navbar-toggle-button ${isClosed ? "closed" : ""}`}
            onClick={handleClick}
            sx={{ display: isSmallScreen ? "none" : "flex", alignItems: "center" }}
          >
            {isClosed ? <ArrowForwardIosIcon /> : <ArrowBackIosIcon />}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
